<template>
  <v-card>
    <v-card-title>検索フォームの設定 IndexSearchForm.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <!-- {{ searchs }} -->
          <div v-for="(s, i) in searchs" :key="i" class="mb-4">
            <v-row>
              <v-col cols="12" v-if="i != 0 && s.name != 'csv'">
                <v-radio-group label="" v-model="s.value" row>
                  <v-radio label="データフィルタ" value="filter"></v-radio>
                  <v-radio label="全検索" value="all"></v-radio>
                  <v-radio label="特定レコード検索" value="recode"></v-radio>
                  <v-radio
                    label="複数レコード指定検索"
                    value="anyrecode"
                  ></v-radio>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="年月日"
                        value="date"
                        v-bind="attrs"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <span>
                      ラベルをドットで区切ると別々の名前で指定できます。ドットが無い場合は2つとも同じ名前になります。
                      例(label1.label2)=>[開始日ラベル(label1)
                      終了日ラベル(label2)]
                    </span>
                  </v-tooltip>
                  <v-radio
                    label="特定レコード ドロップダウンリスト"
                    value="droplist"
                    @change="s.rules5 = 'required'"
                  ></v-radio>
                  <v-radio
                    label="特定レコード 上位絞り込みドロップダウンリスト"
                    value="droplistDetail"
                  ></v-radio>
                  <v-radio
                    label="特定レコード ドロップダウンリスト(固定値)"
                    value="droplistFix"
                  ></v-radio>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="状態検索"
                        value="listState"
                        v-bind="attrs"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <span
                      >左から順番にid1:ラベル1.id2:ラベル2.id3:ラベル3とした場合,
                      [id1有,id2無=ラベル1],[id2有,id3無=ラベル2],[id3有=ラベル3]となる</span
                    >
                  </v-tooltip>
                </v-radio-group>
              </v-col>
              <v-col cols="3" v-if="i != 0 && s.name != 'csv'">
                <!--
                <v-text-field
                  label="サイズ"
                  v-model="s.cols"
                  :rules="[varidation.oneOrmore]"
                ></v-text-field>
                -->
                <set-Cols
                  :value="String(s.cols)"
                  v-on:set="$set(searchs[i], 'cols', $event)"
                ></set-Cols>
              </v-col>
              <v-col
                cols="2"
                v-if="
                  i != 0 &&
                    s.name != 'csv' &&
                    (i + 1 == searchs.length || searchs[i + 1].name == 'csv')
                "
              >
                <v-select
                  :items="$store.state.colors"
                  :background-color="s.color"
                  v-model="s.color"
                  label="ボタンの色"
                ></v-select>
              </v-col>
              <v-col cols="4" v-if="i != 0 && s.name != 'csv'">
                <v-text-field label="ラベル" v-model="s.path"></v-text-field>
              </v-col>
              <v-col
                cols="2"
                v-if="i != 0 && s.name != 'csv' && s.value == 'date'"
              >
                <v-text-field
                  label="form_id"
                  v-model="s.target_id"
                  required
                  :rules="[varidation.numonly]"
                ></v-text-field>
              </v-col>
              <v-col
                cols="2"
                v-if="i != 0 && s.name != 'csv' && s.value == 'date'"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="デフォルト値 開始日"
                      v-model="defaultStart"
                      required
                      :rules="[]"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <span>
                    指定方法<br />
                    +1d：1日後<br />-2m：2か月前<br />+0d：今日<br />
                    monthly：今月1～末まで<br />
                    空の時は開始日は1週間前、終了日は今日の日付になります。
                  </span>
                </v-tooltip>
              </v-col>
              <v-col
                cols="2"
                v-if="i != 0 && s.name != 'csv' && s.value == 'date'"
              >
                <v-text-field
                  label="デフォルト値 終了日"
                  v-model="defaultEnd"
                  required
                  :rules="[]"
                ></v-text-field>
              </v-col>
              <v-col
                cols="2"
                v-if="i != 0 && s.name != 'csv' && s.value == 'recode'"
              >
                <!--
                <v-text-field
                  label="form_id"
                  v-model="s.target_id"
                  required
                  :rules="[varidation.numonly]"
                ></v-text-field>
                -->
                <search-Page
                  label="form_id"
                  v-model.number="s.target_id"
                  required
                  samePage
                  :initPageID="Number(page_id)"
                ></search-Page>
              </v-col>
              <v-col
                cols="2"
                v-if="i != 0 && s.name != 'csv' && s.value == 'anyrecode'"
              >
                <v-text-field
                  label="form_id(.区切り)"
                  v-model="s.target_id"
                  required
                  :rules="[varidation.numANDcomma]"
                ></v-text-field>
              </v-col>
              <v-col
                cols="4"
                v-if="i != 0 && s.name != 'csv' && s.value == 'droplist'"
              >
                <v-text-field
                  label="form_id[一覧表示対象.検索対象]"
                  v-model="s.target_id"
                  required
                  :rules="[varidation.numANDcomma]"
                ></v-text-field>
              </v-col>
              <v-col
                cols="4"
                v-if="i != 0 && s.name != 'csv' && s.value == 'droplistDetail'"
              >
                <v-text-field
                  label="form_id[一覧対象.親レポート絞り込み条件.検索対象]"
                  v-model="s.target_id"
                  required
                  :rules="[varidation.numANDcomma]"
                ></v-text-field>
                *絞り込み条件は上行の検索欄が対象となる
              </v-col>
              <v-col
                cols="4"
                v-if="i != 0 && s.name != 'csv' && s.value == 'droplistFix'"
              >
                <v-text-field
                  label="form_id[検索対象.選択肢]"
                  v-model="s.target_id"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="4"
                v-if="i != 0 && s.name != 'csv' && s.value == 'listState'"
              >
                <v-text-field
                  label="form_id[検索対象：表示名](.区切り)"
                  v-model="s.target_id"
                  :rules="[]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row
              v-if="
                (i != 0 && s.name != 'csv' && s.rules != undefined) ||
                  (s.rules == null && s.name != 'csv')
              "
            >
              <v-col cols="2">
                <v-checkbox
                  v-model="s.rules"
                  label="必須項目"
                  value="required"
                ></v-checkbox>
              </v-col>
              <v-col cols="2">
                <v-checkbox
                  v-model="s.rules6"
                  label="全角のみ"
                  value="fullWidth"
                ></v-checkbox>
              </v-col>
              <v-col cols="2">
                <v-checkbox
                  v-model="s.rules4"
                  label="非表示"
                  value="hide"
                ></v-checkbox>
              </v-col>
              <v-col cols="2">
                <v-checkbox
                  v-model="s.rules11"
                  label="一般のみ非表示"
                  value="commonHide"
                ></v-checkbox>
              </v-col>
              <v-col
                cols="2"
                v-if="s.value == 'recode' || s.value == 'anyrecode'"
              >
                <v-checkbox
                  v-model="s.rules8"
                  label="サブページを検索"
                  value="subpage"
                ></v-checkbox>
                ※孫ページ非対応
              </v-col>
              <v-col
                v-if="
                  s.value == 'droplist' ||
                    s.value == 'droplistDetail' ||
                    s.value == 'droplistFix'
                "
              >
                <v-checkbox
                  v-model="s.rules3"
                  label="複数選択可"
                  value="required"
                ></v-checkbox>
              </v-col>
              {{ s.rules5 }}***

              <v-col
                v-if="
                  s.value == 'droplist' ||
                    s.value == 'droplistDetail' ||
                    s.value == 'droplistFix'
                "
              >
                <v-checkbox
                  v-model="s.rules5"
                  label="完全一致検索"
                  value="required"
                ></v-checkbox>
              </v-col>
              <v-col
                v-if="
                  s.value == 'droplist' ||
                    s.value == 'droplistDetail' ||
                    s.value == 'droplistFix'
                "
              >
                <v-checkbox
                  v-model="s.rules7"
                  label="サジェスト機能"
                  value="suggest"
                ></v-checkbox>
              </v-col>
              <v-col v-if="s.value == 'anyrecode'">
                <v-checkbox
                  v-model="s.rules9"
                  label="プルダウンリスト(固定値)"
                  value="anyrecodeDropList"
                ></v-checkbox>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="デフォルト値"
                  v-model="s.rules2"
                  required
                  :rules="[]"
                  hint="{form_id}でユーザ情報初期値に設定 {{}}で特殊関数名"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" v-if="s.rules9 == 'anyrecodeDropList'">
                <v-text-field
                  label="プルダウンリスト(.区切り)"
                  v-model="s.rules10"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="red white--text" @click="del">削除</v-btn>
      <v-btn color="primary" @click="add">追加</v-btn>
      <v-spacer></v-spacer>
      <v-btn :color="color + ' white--text'" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import searchPage from "../ReportCreate/common/searchPage.vue";
import setCols from "../ReportCreate/common/setCols.vue";
export default {
  props: {
    //searchs: Object,
    searchs: Array,
    page_id: { default: 0, type: Number },
    //delete_area: Array,
  },
  components: {
    searchPage,
    setCols,
  },
  data() {
    return {
      delete_area: [],
      returnData: {
        searchs: this.searchs,
        delete_area: this.delete_area,
      },
      //年月日デフォルト値
      defaultStart: "",
      defaultEnd: "",
      //バリデーション
      valid: true,
      varidation: {
        oneOrmore: (value) => {
          return /^[1-9]*$/.test(value) || "1以上で入力";
        },
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        numANDcomma: (value) => {
          return /^[0-9.]*$/.test(value) || "数値コロンのみ";
        },
      },
      MAX_SEARCH: 8, //検索フォーム数上限
    };
  },
  mounted() {
    // 日付検索デフォルト値 分解処理
    this.returnData.searchs.forEach((search) => {
      if (search.value == "date") {
        const defaultValue = search.path.split(":");
        for (let i = 0; i < defaultValue.length; i++) {
          switch (i) {
            case 0:
              search.path = defaultValue[i];
              break;
            case 1:
              this.defaultStart = defaultValue[i];
              break;
            case 2:
              this.defaultEnd = defaultValue[i];
              break;
            default:
              console.log("日付デフォルト値設定が異常です。");
          }
        }
      }
    });
    // カラー、ルール分解処理
    for (let i = 0; i < this.returnData.searchs.length; i++) {
      //0番目の要素はヘッダー情報なので無視
      if (i > 0) {
        if (this.returnData.searchs[i].color != undefined) {
          const colorAndRule = this.returnData.searchs[i].color.split(",");
          this.returnData.searchs[i].color = colorAndRule[0];
          //1回目の読み込み時のバグ対策
          if (colorAndRule.length > 1) {
            this.returnData.searchs[i].rules = colorAndRule[1];
            this.returnData.searchs[i].rules2 = colorAndRule[2];
            this.returnData.searchs[i].rules3 = colorAndRule[3];
            this.returnData.searchs[i].rules4 = colorAndRule[4];
            this.returnData.searchs[i].rules5 = colorAndRule[5];
            this.returnData.searchs[i].rules6 = colorAndRule[6];
            this.returnData.searchs[i].rules7 = colorAndRule[7];
            this.returnData.searchs[i].rules8 = colorAndRule[8];
            this.returnData.searchs[i].rules9 = colorAndRule[9];
            this.returnData.searchs[i].rules10 = colorAndRule[10];
            this.returnData.searchs[i].rules11 = colorAndRule[11];
            //
          } else if (
            typeof this.returnData.searchs[i].rules != "undefined" ||
            this.returnData.searchs[i].rules != ""
          ) {
            const tmp = this.returnData.searchs[i].rules.split(",");
            this.returnData.searchs[i].rules = tmp[0];
            this.returnData.searchs[i].rules2 = tmp[1];
            this.returnData.searchs[i].rules3 = tmp[2];
            this.returnData.searchs[i].rules4 = tmp[3];
            this.returnData.searchs[i].rules5 = tmp[4];
            this.returnData.searchs[i].rules6 = tmp[5];
            this.returnData.searchs[i].rules7 = tmp[6];
            this.returnData.searchs[i].rules8 = tmp[7];
            this.returnData.searchs[i].rules9 = tmp[8];
            this.returnData.searchs[i].rules10 = tmp[9];
            this.returnData.searchs[i].rules11 = tmp[10];
          }
          //動いてないっぽい
          if (colorAndRule.length > 1) {
            this.returnData.searchs[i].rules = colorAndRule[1];
          }
        }
      }
    }
  },
  computed: {
    color: function() {
      if (
        this.searchs.length < 2 ||
        this.searchs[this.searchs.length - 1].name == "csv"
      ) {
        return "success";
      }
      //csvフォームがない場合
      if (
        this.searchs.length < 2 ||
        this.searchs[this.searchs.length - 1].name != "csv"
      ) {
        return this.searchs[this.searchs.length - 1].color;
      }
      //
      return this.searchs[this.searchs.length - 2].color;
    },
  },
  methods: {
    submit() {
      //バリデーション
      if (this.$refs.form.validate()) {
        let flag = true;
        //日付検索デフォルト値 連結処理
        this.returnData.searchs.forEach((search) => {
          if (search.value == "date") {
            if (
              (this.defaultStart != "" || this.defaultEnd != "") &&
              typeof search.rules2 != "undefined" &&
              search.rules2 != ""
            ) {
              console.log("search.rules2", search.rules2);
              alert(
                "デフォルト値 開始・終了日を設定しているときは、デフォルト値を空にしてください"
              );
              flag = false;
              return;
            }
            search.path += ":" + this.defaultStart;
            search.path += ":" + this.defaultEnd;
          }
          //search.rules = "";
          search.rules += "," + search.rules2;
          search.rules += "," + search.rules3;
          search.rules += "," + search.rules4;
          search.rules += "," + search.rules5;
          search.rules += "," + search.rules6;
          search.rules += "," + search.rules7;
          search.rules += "," + search.rules8;
          search.rules += "," + search.rules9;
          search.rules += "," + search.rules10;
          search.rules += "," + search.rules11;
        });
        if (flag) {
          this.$emit("clickSubmit", this.returnData);
        }
      }
    },
    add() {
      if (this.searchs.length == 1) {
        this.searchs.push({
          type: 5,
          path: "",
          list_pageID: this.searchs[0].list_pageID,
          value: "filter",
          rules: "",
          cols: "4",
          color: "primary",
          target_id: 0,
        });
        this.searchs.push({
          type: 5,
          name: "csv",
          list_pageID: this.searchs[0].list_pageID,
          value: "",
        });
      } else if (this.searchs.length <= this.MAX_SEARCH) {
        this.searchs.splice(this.searchs.length - 1, 0, {
          type: 5,
          path: "",
          list_pageID: this.searchs[0].list_pageID,
          value: "filter",
          rules: "",
          cols: "4",
          color: this.searchs[this.searchs.length - 2].color,
          target_id: 0,
        });
      }
    },
    del() {
      if (this.searchs.length > 2) {
        console.log(this.searchs);
        let tmp = this.searchs.splice(-2, 1);
        this.delete_area.push(tmp[0]);
        this.returnData.delete_area = this.delete_area;
      }
    },
  },
};
</script>
